import script from "./CasinoCategoryGames.vue?vue&type=script&setup=true&lang=js"
export * from "./CasinoCategoryGames.vue?vue&type=script&setup=true&lang=js"

import "./CasinoCategoryGames.vue?vue&type=style&index=0&id=7d0d149a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d0d149a"]])

export default __exports__